exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media print{button[data-v-9ef8a9ba]{display:none}}.p-t-b[data-v-9ef8a9ba]{margin-top:5px;margin-bottom:5px}small[data-v-9ef8a9ba]{font-size:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9ef8a9ba","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/school/core/header.vue
// module id = 181
// module chunks = 0